import { FontWeight } from "../../../../base/styles";
import clsx from "clsx";

export const SelectFontWeight = ({ title, value, className, onChange }:{
    title: string,
    value?: FontWeight,
    className?: string,
    onChange: (value?: FontWeight) => void,
}) => {
    const handleOnSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = e.target.value as FontWeight;
        newValue ? onChange(newValue) : onChange(undefined);
    }

    return (
        <div className={clsx(className, "field-group mb-2")}>
            <label className="fs-8 fw-bold text-gray-600">{title}</label>
            <select
                onChange={handleOnSelectionChange}
                value={value || ""}
                className="form-select form-select-sm form-control-xs">
                <option></option>
                <option value={FontWeight.Bold}>Bold</option>
                <option value={FontWeight.Bolder}>Bolder</option>
                <option value={FontWeight.Semibold}>Semibold</option>
                <option value={FontWeight.Normal}>Normal</option>
                <option value={FontWeight.Light}>Light</option>
                <option value={FontWeight.Lighter}>Lighter</option>
            </select>
        </div>
    )
}